import { graphql } from "~/gql";

export const filteredDesignsQuery = graphql(/* GraphQL */ `
  query FilteredDesigns($filter: OutputDesignWhereInput!) {
    filteredDesigns(filter: $filter) {
      id
      title
      description
      htmlContent
      type
      active
      default
      defaultForOrgUnits {
        id
      }
      groupItemId
      removeTemplateMargin
    }
  }
`);

export const cloneDesignMutation = graphql(/* GraphQL */ `
  mutation CloneDesign($id: Float!) {
    cloneDesign(id: $id) {
      id
    }
  }
`);

export const createDesignMutation = graphql(/* GraphQL */ `
  mutation CreateDesign($data: OutputDesignCreateInput!) {
    createDesign(data: $data) {
      id
    }
  }
`);

export const updateDesignMutation = graphql(/* GraphQL */ `
  mutation UpdateDesigns($data: [UpdateDesignsInput!]!, $designType: String!) {
    updateDesigns(data: $data, designType: $designType) {
      id
      title
      description
      htmlContent
      type
      active
    }
  }
`);

export const deleteDesignMutation = graphql(/* GraphQL */ `
  mutation DeleteDesign($id: Float!) {
    deleteDesign(id: $id)
  }
`);

export const getProposalMergeTagsQuery = graphql(/* GraphQL */ `
  query GetProposalMergeTags {
    getProposalMergeTagFields {
      title
      value
    }
  }
`);

export const getClientReportMergeTagsQuery = graphql(/* GraphQL */ `
  query GetClientReportMergeTags {
    getClientReportMergeTagFields {
      title
      value
    }
  }
`);

export const GET_TEXT_BLOCKS = graphql(/* GraphQL */ `
  query GetTextBlocks($matterId: Float!) {
    getTextBlocks(matterId: $matterId) {
      content
      id
      title
    }
  }
`);

export const RESET_PROPOSAL_OUTPUTS = graphql(/* GraphQL */ `
  mutation Mutation {
    resetExistingProposals
  }
`);
